// extracted by mini-css-extract-plugin
export var btnArrow = "s-module--btnArrow--1affc";
export var btnBlack = "s-module--btnBlack--9ceb3";
export var btnBlue = "s-module--btnBlue--5eaa3";
export var btnGrey = "s-module--btnGrey--ca872";
export var btnLgCenter = "s-module--btnLgCenter--63257";
export var btnOrange = "s-module--btnOrange--367b3";
export var btnPrimary = "s-module--btnPrimary--8f3c8";
export var btnRvSmall = "s-module--btnRvSmall--09ff6";
export var btnSecondary = "s-module--btnSecondary--64f9d";
export var btnSmall = "s-module--btnSmall--50df3";
export var button = "s-module--button--0f722";
export var disabled = "s-module--disabled--8270d";
export var iconLeft = "s-module--iconLeft--716d9";
export var iconRight = "s-module--iconRight--0a468";